import { FiAlignLeft, FiCalendar, FiCheckSquare, FiHash, FiList, FiType } from "react-icons/fi";
import type { IconType } from "react-icons";
import type { CustomFormFieldType } from "./types";

// Post-submit screen copy shown when the form doesn't set its own.
export const DEFAULT_RESPONSE_SCREEN_HEADER = "Thanks!";
export const DEFAULT_RESPONSE_SCREEN_TEXT = "Your response has been recorded.";

export const FIELD_TYPE_LABEL: Record<CustomFormFieldType, string> = {
  short_text: "Short text",
  long_text: "Long text",
  single_select: "Dropdown",
  multi_select: "Checkboxes",
  date: "Date",
  number: "Number",
};

export const FIELD_TYPE_ICON: Record<CustomFormFieldType, IconType> = {
  short_text: FiType,
  long_text: FiAlignLeft,
  single_select: FiList,
  multi_select: FiCheckSquare,
  date: FiCalendar,
  number: FiHash,
};

// Palette display order — mirrors the vertical stacking on the left rail.
export const FIELD_TYPES_IN_PALETTE_ORDER: CustomFormFieldType[] = [
  "short_text",
  "long_text",
  "number",
  "date",
  "single_select",
  "multi_select",
];

export const SELECT_FIELD_TYPES: CustomFormFieldType[] = ["single_select", "multi_select"];

export const PREVIEW_PLACEHOLDER: Partial<Record<CustomFormFieldType, string>> = {
  short_text: "Short answer text",
  long_text: "Long answer text",
  date: "Month, day, year",
  number: "0",
};

export const PREVIEW_PLACEHOLDER_WIDTH: Partial<Record<CustomFormFieldType, string>> = {
  short_text: "60%",
  long_text: "100%",
  date: "40%",
  number: "20%",
};
